import { Button } from '../button';
import { ReactNode } from 'react';
import { downloadFile } from '@/util/helpers';
import { useGenerateReferralLetterPdf } from '@/api/generate-referral-letter-pdf';

interface DownloadReferralLetterButtonProps {
  encounterId: number;
  children: ReactNode;
  fileName: string;
  className?: string;
}

export function DownloadReferralLetterButton({
  encounterId,
  className,
  fileName,
  children,
}: DownloadReferralLetterButtonProps) {
  const { mutate: generateReferralLetterPdf, isPending } = useGenerateReferralLetterPdf();

  const handleDownloadPdf = () => {
    generateReferralLetterPdf(
      { encounterId },
      { onSuccess: (data) => downloadFile(data, fileName) },
    );
  };

  return (
    <Button
      variant="link"
      leftIcon="description"
      loading={isPending}
      onClick={handleDownloadPdf}
      className={className}
    >
      {children}
    </Button>
  );
}
